import { useMutation } from '@tanstack/react-query';
import { saveUserDevice } from './saveUserDevice';
import { handleAxiosErrorMessage } from '../../../../utils';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setMessage } from '../../../toasts/toastSlice';
import { NOTIFICATION_TYPES } from '../../../../config/consts/commons';

export default function useSaveUserDevice() {
  const { t } = useTranslation(['system']);
  const dispatch = useDispatch();

  return useMutation({
    mutationKey: ['saveUserDevice'],
    mutationFn: (payload) => saveUserDevice(payload),
    onSuccess: () => {
      dispatch(
        setMessage({
          body: t('USER_DEVICE_CREATED_SUCCESS', { ns: 'system' }),
          type: NOTIFICATION_TYPES.SUCCESS,
        })
      );
    },
    onError: (error) => {
      const errorMessage = handleAxiosErrorMessage(error);

      if (errorMessage === 'USER_DEVICE_EXIST') {
        console.error('USER_DEVICE_EXIST');
      } else {
        dispatch(
          setMessage({
            body: t(errorMessage, { ns: 'system' }),
            type: NOTIFICATION_TYPES.ERROR,
          })
        );
      }
    },
  });
}
